import React, { useRef, useState } from "react";
import * as XLSX from "xlsx";
import { IconButton } from "@mui/material";
import { FaFileImport } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import actions from "store/actions";
import { State } from "store/reducers";
import { BankBilletState } from "store/reducers/bankBillet";
import Spinner from "Components/Spinner";
import IBankBillet from "Types/BankBillet";
import dayjs from "dayjs";
import ls from "Localization";
// import ReactExport from "react-export-excel";

import { toStringCurrency } from "helpers/string";

// const ExcelFile = ReactExport.ExcelFile;
// const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

function ImportBankBillet({ load }: { load: () => void }) {
	const dispatch = useDispatch<any>();

	const [exportComponent, setExport] = useState<React.ReactNode>(null);

	const { loading } = useSelector<State, BankBilletState>(s => s.bankBillet);

	const inputFile: any = useRef<HTMLInputElement>(null);

	const openSelectFile = () => {
		if (inputFile.current) {
			inputFile.current.click();
		}
	};

	const handleExport = (data: IBankBillet[]) => {
		const columns = [
			"Data criação",
			"Nº Documento",
			"Nome",
			"E-mail",
			"Valor",
			"Vencimento",
			"Código de barra",
			"Link"
		];

		const excelData = data.map((c: any) => [
			dayjs(c.createdAt).format(ls.dateFormatWithoutSeconds),
			c.referenceNumber,
			c.name,
			c.email,
			toStringCurrency(+c.value / 100.0),
			c.dueDate,
			c.barCode,
			c.url
		]);

		// setExport(
		// 	<ExcelFile
		// 		filename={"Boletos" + "_" + dayjs().format("YYYY-MM-DD-kk-mm-ss")}
		// 		hideElement
		// 	>
		// 		<ExcelSheet dataSet={[{ columns, data: excelData }]} name="Boletos" />
		// 	</ExcelFile>
		// );

		setTimeout(() => {
			setExport(null);
		}, 1000);
	};

	const handleFileSelected = (e: any) => {
		const file = e.target.files[0];
		if (!file) return;

		const reader = new FileReader();
		const rABS = !!reader.readAsBinaryString;
		reader.onload = (e: any) => {
			/* Parse data */
			const bstr = e.target.result;
			const wb = XLSX.read(bstr, { type: rABS ? "binary" : "array" });
			/* Get first worksheet */
			const wsname = wb.SheetNames[0];
			const sheet = wb.Sheets[wsname];

			type DataItem = { [key: string]: any }[];
			const data: DataItem = XLSX.utils.sheet_to_json(sheet);

			for (const d of data) {
				if (d["Split"]) {
					const splitSheet = wb.Sheets[d["Split"]];
					d["Split"] = XLSX.utils.sheet_to_json(splitSheet);
				}
			}

			dispatch(
				actions.bankBillet.importBankBillets(
					data.map((c: any) => ({
						payer: c["Pagador"],
						seller: c["Recebedor"],
						value: Math.round(c["Valor"] * 100),
						dueDate: c["Vencimento"],
						description: c["Descrição"],
						splits: c["Split"]?.map((s: any) => ({
							recipient: s["Recebedor"],
							value: Math.round(s["Valor"] * 100)
						}))
					})),
					(err, data: any) => {
						if (err) {
							if (typeof err !== "string") err = JSON.stringify(err);
							alert(err);
						} else {
							load();
							handleExport(data);
						}
					}
				)
			);
		};

		if (rABS) reader.readAsBinaryString(file);
		else reader.readAsArrayBuffer(file);

		inputFile.current.value = null;
	};

	return (
		<div>
			{loading.import ? (
				<Spinner size={24} />
			) : (
				<IconButton onClick={openSelectFile}>
					<FaFileImport />
				</IconButton>
			)}
			<input
				ref={inputFile}
				style={{ display: "none" }}
				type="file"
				accept="application/excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
				onChange={handleFileSelected}
			/>
			{exportComponent}
		</div>
	);
}

export default ImportBankBillet;
